module.exports = __webpack_public_path__ + "media/application/images/flags/en-32-0af1fef883def639b5099f883b033a36.png";